import magnifiAPIInstance from "./apiInstance";

export const audioAPIs = {
  getAudios: ({ payload }) => magnifiAPIInstance.post(`/get-audio`, payload),
  deleteAudio: ({ payload }) => magnifiAPIInstance.delete(`/delete-audio/${payload}`),
  uploadAudio: ({ payload }) => magnifiAPIInstance.post(`/upload-audio`, payload),
  getAudioDetails: ({ id }) => magnifiAPIInstance.get(`/api/v3/get-audio-details/${id}`),
};
